<script setup lang="ts">
const { scrollToId } = useScrollTo()

import LineCheckpoint from "@/components/LineCheckpoint.vue";
import FrameServiceSphere from "@/components/frames/FrameServiceSphere.vue";
import Button from "@/components/Button.vue";

import ATitle from "@/components/io/atomic/atoms/fragments/content/ATitle.vue";


withDefaults(defineProps<{
  id: string
  sectionTitle: string
  dir: 'ltr' | 'rtl'
}>(), {
  id: 'discovery',
  sectionTitle: 'Assessment & Discovery',
  dir: 'ltr'
})
</script>

<template>
  <Frame :id="id" class="sec-sphere-section" :class="[`${id}-section`, `dir-${dir}`]" w='max-w-85% mx-auto grid g-1'>
    <FrameServiceSphere class="frame-title">
      <template #left>
        <LineCheckpoint :class="`check-${id}`" :id="`chk${id}`" />
      </template>

      <template #content>
        <ATitle class="sphere-service-title lt-t:bg-white" :primary="`${sectionTitle}`" />
      </template>
    </FrameServiceSphere>

    <FrameServiceSphere class="frame-content gmb-2">
      <!-- <template #left>
            &nbsp;
          </template> -->

      <template #content>

        <Frame class="sec-sphere-content" :class="`dir-${dir}`" w="grid grid-cols-[1fr] ds:grid-cols-[1fr_1fr] g-3">
          <Frame class="col-media relative" w="ds:sticky! ds:top-100px!">
            <slot name="media" />
          </Frame>
          <Frame class="col-content" w="bg-white">
            <slot name="content" />

          </Frame>
        </Frame>


      </template>
    </FrameServiceSphere>

    <FrameServiceSphere class="frame-blocks">
      <template #content>

        <Frame class="sec-blocks" w="grid gc-300px g-1 t:g-2 ds:g-2">
          <slot name="blocks" />

        </Frame>

      </template>
    </FrameServiceSphere>
  </Frame>
</template>

<style lang="scss" scoped>
.sec-sphere-section {
  :deep(.sphere-service-title) {
    .a-title-primary {
      font-family: var(--font-secondary);
    }
  }
}

.frame-content {
  :deep(p) {
    margin-bottom: 0;
  }

  .sec-sphere-content {
    &.dir-rtl {
      .col-media {
        order: 2;
      }

      .col-content {
        order: 1;
      }
    }

    &.dir-ltr {
      .col-media {
        order: 1;
      }

      .col-content {
        order: 2;
      }
    }
  }
}
</style>